module.exports = __webpack_public_path__ + "img/Betting_text01_whychoose.58438eae.png";